import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import CustomBackdrop from '../../../../components/backdrop';
import getEnvironement from '../../../../environnement';
import CustomInput from '../../../../components/customInput';

export default function AddDialog({
  open,
  handleOpen,
  handleClose,
  reloadData,
}) {
  const [departement, setDepartement] = useState('');
  const [departementEn, setDepartementEn] = useState('');
  const [departementError, setDepartementError] = useState('');
  const [departementEnError, setDepartementEnError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function addDepartement() {
    const url = `${getEnvironement().API_URL}/departements`;
    const data = {
      departement,
      departementEn
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => reloadData())
      .then(() => setTimeout(() => toast.success('Le département a bien été ajouté'), 800))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.departement ? setDepartementError(err.response.data.errors.departement[0]) : setDepartementError('');
          err.response.data.errors.departementEn ? setDepartementEnError(err.response.data.errors.departementEn[0]) : setDepartementEnError('');
          handleOpen();
        }
      });
  }

  useEffect(() => {
    setDepartement('');
    setDepartementEn('');
    if (!open) {
      setDepartementError('');
      setDepartementEnError('');
    }
  }, [open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Ajouter un département :</p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomInput
              type='text'
              placeholder='Département'
              value={departement}
              setValue={setDepartement}
              isError={departementError !== ''}
              error={departementError}
            />
            <CustomInput
              type='text'
              placeholder='Département (anglais)'
              value={departementEn}
              setValue={setDepartementEn}
              isError={departementEnError !== ''}
              error={departementEnError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={addDepartement}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Ajouter</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
